<template>
    <transition name="modal-fade">
		<div class="modal modal-mask" style="display: block">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ lang['module.editor_label'] }}</h5>
                        <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="prompt">{{ lang['module.editor_description'] }}</div>

                        <div class="edit-row mt-3 flex-end">
                            <label for="shared" class="mr-3">{{ lang['module.editor_existing_label'] }}</label>
                            <label class="switch">
                                <input type="checkbox" id="shared" v-model="use_existing">
                                <span class="slider-switch round"></span>
                            </label>
                        </div>


                        <div class="mt-3 modal-section mb-3">
                            <template v-if="use_existing">

                                <template v-if="noModules">
                                    <div>{{ lang['module.no_module_description'] }}</div>
                                </template>

                                <template v-else>

                                    <div class="form-group" v-if="modules.length > 0">
                                        <label for="moduleName">{{ lang['module.select_label'] }}</label>
                                        <div class="dropdown-wrapper">
                                            <button class="dropdown-btn" @click="selectOpen = !selectOpen; nameError = false; linkError = false;"><div id="moduleSelectBtnTxt">{{ selectedModuleName | truncate(80) }}</div><i class="fas fa-sort-down"></i></button>
                                            <div class="options-wrapper" v-if="selectOpen" style="z-index: 5;">
                                                <div class="option" v-for="item in modules" @click="selectModule(item)">{{ item.name | truncate(80) }}</div>
                                            </div>
<!--                                            <select class="options-wrapper" style="z-index: 5;" @change="selectModule(value)">-->
<!--                                                <option class="option" :value="item.id" v-for="item in modules" :selected="(selectedModuleName == item.name)">{{ item.name }}</option>-->
<!--                                            </select>-->
                                        </div>
                                    </div>

                                    <div v-else class="form-group">
                                        <label for="moduleName">{{ lang['module.name'] }}</label>
                                        <div name="moduleName" id="moduleName">{{ name }}</div>
                                    </div>

                                    <div class="form-group">
                                        <label for="moduleLink">{{ lang['module.link_description'] }}</label>
                                        <div class="d-flex flex-space">
                                            <div name="moduleLink" id="moduleLink" required="true" @keyup="linkError = false" style="word-break: break-word;">{{ link }}</div>
                                            <a :href="link" target="blank"><button class="btn btn-primary ml-3" :disabled="!link || link.length == 0 || !isURL(link)">{{ lang['module.preview'] }}</button></a>
                                        </div>
                                    </div>
                                </template>

                            </template>

                            <template v-else>
                                <div v-if="nameError" class="alert alert-danger" role="alert">
                                    {{ lang['module.name_prompt'] }}
                                </div>

                                <div class="form-group">
                                    <label for="moduleNewName">{{ lang['module.name'] }}</label>
                                    <input type="text" name="moduleNewName" class="form-control" id="moduleNewName" required="true" maxlength="50" v-model="newName" @keyup="nameError = false">
                                </div>

                                <div v-if="linkError" class="alert alert-danger" role="alert">
                                    {{ lang['module.link_prompt'] }}
                                </div>
                                <div class="form-group">
                                    <label for="moduleNewLink">{{ lang['module.link_description'] }}</label>
                                    <div class="d-flex flex-space">
                                        <input type="text" name="moduleNewLink" class="form-control" id="moduleNewLink" required="true" v-model="newLink" placeholder="https://www.site...." @keyup="linkError = false">
                                        <a :href="link" target="blank"><button class="btn btn-primary ml-3" :disabled="!newLink || newLink.length == 0 || !isURL(newLink)">{{ lang['module.preview'] }}</button></a>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <template v-if="moduleData.type=='decision'">
                            <div class="form-group mt-3">
                                <label for="modulePrompt">{{ lang['module.decision_label'] }}</label>
                                <input type="text" name="modulePrompt" class="form-control" id="modulePrompt" required="true" v-model="prompt" :placeholder="lang['model.module_prompt']">
                            </div>
                        </template>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeModal">{{ lang['button.cancel'] }}</button>
                        <button type="button" class="btn btn-delete" @click="removeItem()" v-if="!isNew">{{ lang['button.remove'] }}</button>
                        <button type="button" class="btn btn-primary btn-gradient" @click="saveModule">{{ lang['button.save'] }}</button>
                    </div>

				</div>
			</div>
		</div>
	</transition>
</template>

<script>

export default {
    props: ['moduleData'],
    data() {
        return {
            id: this.moduleData.id,
            isNew: true,
            link: this.moduleData.link,
            newLink: "",
            linkError: false,
            modules: [],
            noModules: false,
            name: this.moduleData.name,
            newName: "",
            nameError: false,
            prompt: this.moduleData.prompt,
            selectOpen: false,
            selectedModuleName: "",
            use_existing: false,
            lang: lang,
        }
    },

    mounted() {
        this.newLink = "";
        this.newName = "";
        this.selectedModuleName = lang['module.select_placeholder'];
        if(this.moduleData.id > 0) {
            this.isNew = false;
            this.use_existing = true;
        }
        $.get('/modules/' + this.moduleData.modelID,
        res => {
            if(res != 'error') {
                let found = false;
                res.forEach(mod => {
                    if(mod.name && mod.name != "") {
                        this.modules.push(mod);
                        if(mod.id == this.moduleData.id){
                            found = true;
                            this.selectedModuleName = mod.name;
                        }
                    }
                });
                if(this.modules.length == 0){
                    this.noModules = true;
                }

                // If the software THINKS that there should be an existing module, but it's not found...
                if(!found && this.use_existing){
                    this.isNew = true;
                    this.newName = this.name;
                    this.newLink = this.link;
                    this.id = 0;
                    this.name = "";
                    this.link = "";
                }
            }
        }).catch((error) => {
            bus.$emit('popupError', error);
        });
    },

    methods: {
        closeModal() {
            this.name = '';
            this.$emit('close');
        },

        removeItem() {
            const { decisionID:decision_id, modelID:model_id } = this.moduleData;

            $.post('/modules/remove', {decision_id, model_id},
            res => {
                if(res != 'error') {
                    dbNodes[decision_id] && Object.assign(dbNodes[decision_id], {module: null, module_id: 0, prompt: "",  module_name: null});
                    $(".nodeID" + decision_id).remove();
                    this.closeModal();
                    undoEditSave();
                }
            });
        },

        selectModule(item) {
            Object.assign(this, item);
            this.selectOpen = false;
            this.id = item.id;
            this.selectedModuleName = item.name;
        },

        saveModule() {
            const { decisionID, groupID, modelID } = this.moduleData;

            var link, name, id;
            if(this.use_existing){
                id = this.id;
                name = this.name;
                link = this.link;
            }
            else {
                id = 0;
                name = this.newName;
                link = this.newLink;
            }
            var prompt = this.prompt;

            this.linkError = !link || !link.trim().length > 0 || !this.isURL(link);
            this.nameError = !name || !name.trim().length > 0;
            if(!prompt || !prompt.trim().length > 0) {
                prompt = lang['model.module_prompt'];
            }
            if(!this.linkError && !this.nameError) {
                $.post('/modules/' + modelID + '/save', {
                    id,
                    decision_id: decisionID || null,
                    group_id: groupID || null,
                    link,
                    name,
                    prompt
                },
                res => {
                    if(res != 'error') {
                        if(this.moduleData.type == 'decision') {
                            dbNodes[decisionID] && Object.assign(dbNodes[decisionID], { module:link, prompt, module_name: name, module_id: res.id});
                            $(".nodeID" + decisionID).remove();
                            undoEditSave();
                            clickDecision(decisionID);
                        } else {
                            bus.$emit('groupModule', res, prompt);
                        }
                        this.closeModal();
                    }
                })
            }
        },

        isURL(str) {
            if(!str) {
                return true;
            }
            try {
                new URL(str);
                return true;
            }
            catch (_) {
                return false;
            }
        }

    }
}

</script>
